export const TxpScenarioCountryCode = {
  TaxPack: 'TAXPACK',
  TaxConsolidation: 'TAXCONSOLIDATION'
} as const;

export const TxpCountryCodes = [TxpScenarioCountryCode.TaxPack, TxpScenarioCountryCode.TaxConsolidation] as const;
